import {Flex, Text, useDisclosure, Box} from '@chakra-ui/react'
import {isEmpty} from 'lodash-es'
import {useTranslation} from 'next-i18next'
import {useLazyQuery, useQuery, useReactiveVar} from '@apollo/client'
import {AddressForm} from 'modules/checkout/components/AddressForm'
import AddressesModal from 'modules/profile/components/AddressesModal'
import useCustomer from '_app/hooks/useCustomer'
import { GET_COUNTRIES } from '_app/graphql/queries/customer/GetCountries'
import { useCheckoutContext } from '../hooks'
import { STEPS } from '../types'
import {use} from 'i18next'
import {useEffect, useState} from 'react'
import {GetCartDocumentSmall} from '../../../_app/graphql/queries/cart/GetCartDocumentSmall'
import {cartIdVar, emailOnCart} from '../../../_app/cache'

export const DeliveryDetailsCard = () => {
    const {data: countriesData} = useQuery(GET_COUNTRIES)
  const [getCartDocument] = useLazyQuery(GetCartDocumentSmall)
    const {t} = useTranslation('checkout')
    const {customer} = useCustomer()
  const cartId = useReactiveVar(cartIdVar)
  const email = useReactiveVar(emailOnCart)
    const {isOpen, onOpen, onClose} = useDisclosure()
    const {
        step,
        setStep,
        cartCheckoutData,
        isShowroomShippingSelected,
        isParcelLocker,
    } = useCheckoutContext()
  const [shippingAddress, setShippingAddress] = useState<any>(null)
  const getAddressInSecondStep = async () => {
    if (cartCheckoutData?.cart?.shipping_addresses?.length !== undefined && cartCheckoutData?.cart?.shipping_addresses?.length > 0) {
      const tempData: any = await getCartDocument({
        variables: {
          cartId,
        },
      })
      if (tempData) {
        setShippingAddress(tempData?.data?.cart?.shipping_addresses[0])
      }
    }
  }
  useEffect(() => {
    getAddressInSecondStep().then(() => {})
  }, [cartCheckoutData])
  const shippingCountry = (countriesData?.countries || []).find(
    (item: any) => item.id === shippingAddress?.country?.code
  )?.full_name_locale
  const isAddressFilled =
    shippingAddress &&
    !isEmpty(shippingAddress) &&
    shippingAddress?.firstname !== 'firstname'
  return (
    <>
      {isOpen && !!customer && (
        <AddressesModal onClose={onClose} setStep={setStep} />
      )}

            <>
                {step === STEPS.DELIVERY && (
                    <Flex justifyContent="space-between" alignItems="center" mt={16}>
                        <Text fontWeight={600}>
                            {isShowroomShippingSelected
                                ? t('FILL_ORDER_DETAILS')
                                : t('FILL_DELIVERY_DETAILS')}
                        </Text>
                    </Flex>
                )}

        {step !== STEPS.DELIVERY && isAddressFilled && email && (
                    <Box mt={2} ml={7} fontWeight={300}>
                        <Text>
                            {shippingAddress.firstname} {shippingAddress.lastname}
                        </Text>
                        {!isShowroomShippingSelected && !isParcelLocker && (
                            <>
                                <Text>{shippingAddress.street.join(' ')}</Text>
                                <Text>
                                    {shippingAddress.postcode} {shippingAddress.city}
                                </Text>
                                <Text>
                                    {shippingAddress?.country?.code !== 'PL' && shippingCountry}
                                </Text>
                                <Text>{shippingAddress.company}</Text>
                            </>
                        )}
                        <Text>{shippingAddress.telephone}</Text>
                        <Text>{email}</Text>
                    </Box>
                )}

                {step === STEPS.DELIVERY && (
                    <AddressForm
                        onOpen={onOpen}
                        shippingCode={shippingAddress?.country?.code}
                        isAddressHidden={isShowroomShippingSelected || isParcelLocker}
                    />
                )}
            </>
        </>
    )
}
